export enum ToolCategory {
  Configurator,
  Assistant,
}

/**
 * Please keep values synchronised with java file
 * com.hybris.schaeff.facades.productconfig.ConfiguratorType
 */
export enum ToolType {
  System = 1,
  Carriage = 2,
  Rail = 3,
  InchShaft = 9,
  MetricShaft = 10,
  Rotary = 4,
  Housing = 5,
  Heater = 6,
  Lubrication = 8,
}
const MAP = {
  // Configurators
  SYSTEM: ToolType.System,
  CARRIAGE: ToolType.Carriage,
  RAIL: ToolType.Rail,
  METRICSHAFT: ToolType.MetricShaft,
  INCHSHAFT: ToolType.InchShaft,
  // Selection Assistants
  ROTARY: ToolType.Rotary,
  HOUSING: ToolType.Housing,
  HEATER: ToolType.Heater,
  LUBRICATION: ToolType.Lubrication,
};

export const getToolTypeFromString = getEnumFromString(MAP);

export function getEnumFromString<T>(map: Dict<T>) {
  return (val: string): T | null => {
    if (!val) {
      return null;
    }
    return map[val.toUpperCase()] ?? null;
  };
}

export function getRandomTool() {
  const index = Math.floor(Math.random() * Object.keys(MAP).length);
  return Object.values(MAP)[index];
}
